var React = require('react');

function DownloadInline (props) {
    return React.createElement("g",props,[React.createElement("polygon",{"points":"21.3,8.7 16,8.7 16,0.7 8,0.7 8,8.7 2.7,8.7 12,18 \t","key":0}),React.createElement("polygon",{"points":"2.7,20.7 2.7,23.3 21.3,23.3 21.3,20.7 \t","key":1})]);
}

DownloadInline.defaultProps = {};

module.exports = DownloadInline;

DownloadInline.default = DownloadInline;
